import { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';

export default function PrivacyPage() {
  const [isScrolled, setIsScrolled] = useState(false);
  const [mobileMenuOpen, setMobileMenuOpen] = useState(false);

  useEffect(() => {
    const handleScroll = () => {
      setIsScrolled(window.scrollY > 50);
    };
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  const scrollToTop = () => {
    window.scrollTo({ top: 0, behavior: 'smooth' });
  };

  return (
    <div className="min-h-screen bg-gradient-to-br from-slate-950 via-slate-900 to-slate-950 font-sans text-white">
      {/* ヘッダー */}
      <header className={`fixed top-0 left-0 right-0 z-50 transition-all duration-500 ${isScrolled ? 'bg-slate-950/80 backdrop-blur-xl border-b border-cyan-500/20 shadow-lg shadow-cyan-500/10' : 'bg-transparent'}`}>
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="flex items-center justify-between h-20">
            <Link to="/" className="flex items-center">
              <h1 className="text-2xl font-bold bg-gradient-to-r from-cyan-400 via-blue-400 to-purple-400 bg-clip-text text-transparent">
                空間Lab AI研修
              </h1>
            </Link>

            <div className="hidden lg:block">
              <Link to="/" className="text-gray-300 hover:text-cyan-400 transition-all duration-300 text-sm font-medium whitespace-nowrap">
                トップページへ戻る
              </Link>
            </div>

            <button onClick={() => setMobileMenuOpen(!mobileMenuOpen)} className="lg:hidden text-gray-300 cursor-pointer">
              <i className={`${mobileMenuOpen ? 'ri-close-line' : 'ri-menu-line'} text-2xl`}></i>
            </button>
          </div>
        </div>

        {mobileMenuOpen && (
          <div className="lg:hidden bg-slate-950/95 backdrop-blur-xl border-t border-cyan-500/20">
            <div className="px-4 py-4">
              <Link to="/" className="block w-full text-left text-gray-300 hover:text-cyan-400 py-2 transition-colors">
                トップページへ戻る
              </Link>
            </div>
          </div>
        )}
      </header>

      {/* メインコンテンツ */}
      <main className="pt-32 pb-20 px-4 sm:px-6 lg:px-8">
        <div className="max-w-4xl mx-auto">
          <div className="text-center mb-12">
            <h1 className="text-4xl sm:text-5xl font-bold mb-4">
              <span className="bg-gradient-to-r from-cyan-400 to-blue-400 bg-clip-text text-transparent">
                プライバシーポリシー
              </span>
            </h1>
            <p className="text-gray-400">最終更新日：2025年1月1日</p>
          </div>

          <div className="bg-slate-900/50 backdrop-blur-sm border border-cyan-500/20 rounded-3xl p-8 space-y-8">
            <section>
              <h2 className="text-2xl font-bold text-white mb-4 flex items-center gap-3">
                <div className="w-8 h-8 bg-gradient-to-br from-cyan-500/20 to-blue-500/20 border border-cyan-500/30 rounded-lg flex items-center justify-center">
                  <i className="ri-shield-check-line text-cyan-400"></i>
                </div>
                個人情報の取り扱いについて
              </h2>
              <p className="text-gray-300 leading-relaxed mb-4">
                株式会社 空間Lab（以下「当社」）は、お客様の個人情報保護の重要性について認識し、個人情報の保護に関する法律（以下「個人情報保護法」）を遵守すると共に、以下のプライバシーポリシー（以下「本ポリシー」）に従い、適切な取扱い及び保護に努めます。
              </p>
            </section>

            <section>
              <h2 className="text-2xl font-bold text-white mb-4 flex items-center gap-3">
                <div className="w-8 h-8 bg-gradient-to-br from-cyan-500/20 to-blue-500/20 border border-cyan-500/30 rounded-lg flex items-center justify-center">
                  <i className="ri-file-list-line text-cyan-400"></i>
                </div>
                1. 個人情報の定義
              </h2>
              <p className="text-gray-300 leading-relaxed">
                本ポリシーにおいて、個人情報とは、個人情報保護法第2条第1項により定義された個人情報、すなわち、生存する個人に関する情報であって、当該情報に含まれる氏名、生年月日その他の記述等により特定の個人を識別することができるもの（他の情報と容易に照合することができ、それにより特定の個人を識別することができることとなるものを含みます）、もしくは個人識別符号が含まれる情報を意味します。
              </p>
            </section>

            <section>
              <h2 className="text-2xl font-bold text-white mb-4 flex items-center gap-3">
                <div className="w-8 h-8 bg-gradient-to-br from-cyan-500/20 to-blue-500/20 border border-cyan-500/30 rounded-lg flex items-center justify-center">
                  <i className="ri-database-line text-cyan-400"></i>
                </div>
                2. 個人情報の収集方法
              </h2>
              <p className="text-gray-300 leading-relaxed mb-4">
                当社は、以下の方法により個人情報を収集することがあります：
              </p>
              <ul className="space-y-2 text-gray-300">
                <li className="flex items-start gap-2">
                  <i className="ri-check-line text-cyan-400 mt-1 flex-shrink-0"></i>
                  <span>お問い合わせフォームからのご入力</span>
                </li>
                <li className="flex items-start gap-2">
                  <i className="ri-check-line text-cyan-400 mt-1 flex-shrink-0"></i>
                  <span>研修お申し込み時のご入力</span>
                </li>
                <li className="flex items-start gap-2">
                  <i className="ri-check-line text-cyan-400 mt-1 flex-shrink-0"></i>
                  <span>メールや電話でのお問い合わせ</span>
                </li>
                <li className="flex items-start gap-2">
                  <i className="ri-check-line text-cyan-400 mt-1 flex-shrink-0"></i>
                  <span>研修実施時の情報</span>
                </li>
              </ul>
            </section>

            <section>
              <h2 className="text-2xl font-bold text-white mb-4 flex items-center gap-3">
                <div className="w-8 h-8 bg-gradient-to-br from-cyan-500/20 to-blue-500/20 border border-cyan-500/30 rounded-lg flex items-center justify-center">
                  <i className="ri-folder-info-line text-cyan-400"></i>
                </div>
                3. 個人情報の利用目的
              </h2>
              <p className="text-gray-300 leading-relaxed mb-4">
                当社は、収集した個人情報を以下の目的で利用いたします：
              </p>
              <ul className="space-y-2 text-gray-300">
                <li className="flex items-start gap-2">
                  <i className="ri-check-line text-cyan-400 mt-1 flex-shrink-0"></i>
                  <span>研修サービスの提供及び運営</span>
                </li>
                <li className="flex items-start gap-2">
                  <i className="ri-check-line text-cyan-400 mt-1 flex-shrink-0"></i>
                  <span>お問い合わせへの対応</span>
                </li>
                <li className="flex items-start gap-2">
                  <i className="ri-check-line text-cyan-400 mt-1 flex-shrink-0"></i>
                  <span>研修日程の調整及びご連絡</span>
                </li>
                <li className="flex items-start gap-2">
                  <i className="ri-check-line text-cyan-400 mt-1 flex-shrink-0"></i>
                  <span>請求書・領収書の発行</span>
                </li>
                <li className="flex items-start gap-2">
                  <i className="ri-check-line text-cyan-400 mt-1 flex-shrink-0"></i>
                  <span>研修後のフォローアップ</span>
                </li>
                <li className="flex items-start gap-2">
                  <i className="ri-check-line text-cyan-400 mt-1 flex-shrink-0"></i>
                  <span>サービス改善のための分析</span>
                </li>
                <li className="flex items-start gap-2">
                  <i className="ri-check-line text-cyan-400 mt-1 flex-shrink-0"></i>
                  <span>新サービスのご案内（ご希望の方のみ）</span>
                </li>
              </ul>
            </section>

            <section>
              <h2 className="text-2xl font-bold text-white mb-4 flex items-center gap-3">
                <div className="w-8 h-8 bg-gradient-to-br from-cyan-500/20 to-blue-500/20 border border-cyan-500/30 rounded-lg flex items-center justify-center">
                  <i className="ri-lock-line text-cyan-400"></i>
                </div>
                4. 個人情報の安全管理
              </h2>
              <p className="text-gray-300 leading-relaxed">
                当社は、個人情報の紛失、破壊、改ざん及び漏洩などのリスクに対して、個人情報の安全管理が図られるよう、当社の従業員に対し、必要かつ適切な監督を行います。また、個人情報の取扱いを委託する場合は、委託先において個人情報の安全管理が図られるよう、必要かつ適切な監督を行います。
              </p>
            </section>

            <section>
              <h2 className="text-2xl font-bold text-white mb-4 flex items-center gap-3">
                <div className="w-8 h-8 bg-gradient-to-br from-cyan-500/20 to-blue-500/20 border border-cyan-500/30 rounded-lg flex items-center justify-center">
                  <i className="ri-share-line text-cyan-400"></i>
                </div>
                5. 第三者への提供
              </h2>
              <p className="text-gray-300 leading-relaxed mb-4">
                当社は、以下の場合を除き、ご本人の同意を得ることなく、個人情報を第三者に提供することはありません：
              </p>
              <ul className="space-y-2 text-gray-300">
                <li className="flex items-start gap-2">
                  <i className="ri-check-line text-cyan-400 mt-1 flex-shrink-0"></i>
                  <span>法令に基づく場合</span>
                </li>
                <li className="flex items-start gap-2">
                  <i className="ri-check-line text-cyan-400 mt-1 flex-shrink-0"></i>
                  <span>人の生命、身体又は財産の保護のために必要がある場合であって、本人の同意を得ることが困難である場合</span>
                </li>
                <li className="flex items-start gap-2">
                  <i className="ri-check-line text-cyan-400 mt-1 flex-shrink-0"></i>
                  <span>公衆衛生の向上又は児童の健全な育成の推進のために特に必要がある場合であって、本人の同意を得ることが困難である場合</span>
                </li>
                <li className="flex items-start gap-2">
                  <i className="ri-check-line text-cyan-400 mt-1 flex-shrink-0"></i>
                  <span>国の機関もしくは地方公共団体又はその委託を受けた者が法令の定める事務を遂行することに対して協力する必要がある場合であって、本人の同意を得ることにより当該事務の遂行に支障を及ぼすおそれがある場合</span>
                </li>
              </ul>
            </section>

            <section>
              <h2 className="text-2xl font-bold text-white mb-4 flex items-center gap-3">
                <div className="w-8 h-8 bg-gradient-to-br from-cyan-500/20 to-blue-500/20 border border-cyan-500/30 rounded-lg flex items-center justify-center">
                  <i className="ri-cookie-line text-cyan-400"></i>
                </div>
                6. Cookieの使用について
              </h2>
              <p className="text-gray-300 leading-relaxed">
                当社のウェブサイトでは、より良いサービスを提供するため、Cookieを使用することがあります。Cookieの使用を希望されない場合は、ブラウザの設定でCookieを無効にすることができます。ただし、Cookieを無効にした場合、ウェブサイトの一部機能がご利用いただけない場合があります。
              </p>
            </section>

            <section>
              <h2 className="text-2xl font-bold text-white mb-4 flex items-center gap-3">
                <div className="w-8 h-8 bg-gradient-to-br from-cyan-500/20 to-blue-500/20 border border-cyan-500/30 rounded-lg flex items-center justify-center">
                  <i className="ri-user-settings-line text-cyan-400"></i>
                </div>
                7. 個人情報の開示・訂正・削除
              </h2>
              <p className="text-gray-300 leading-relaxed">
                ご本人から個人情報の開示、訂正、削除等の要請があった場合は、本人確認を行った上で、合理的な期間内に対応いたします。個人情報に関するお問い合わせは、下記の連絡先までご連絡ください。
              </p>
            </section>

            <section>
              <h2 className="text-2xl font-bold text-white mb-4 flex items-center gap-3">
                <div className="w-8 h-8 bg-gradient-to-br from-cyan-500/20 to-blue-500/20 border border-cyan-500/30 rounded-lg flex items-center justify-center">
                  <i className="ri-refresh-line text-cyan-400"></i>
                </div>
                8. プライバシーポリシーの変更
              </h2>
              <p className="text-gray-300 leading-relaxed">
                当社は、法令の変更等に伴い、本ポリシーを変更することがあります。変更後のプライバシーポリシーは、本ウェブサイトに掲載した時点から効力を生じるものとします。
              </p>
            </section>

            <section>
              <h2 className="text-2xl font-bold text-white mb-4 flex items-center gap-3">
                <div className="w-8 h-8 bg-gradient-to-br from-cyan-500/20 to-blue-500/20 border border-cyan-500/30 rounded-lg flex items-center justify-center">
                  <i className="ri-mail-line text-cyan-400"></i>
                </div>
                9. お問い合わせ窓口
              </h2>
              <div className="bg-slate-800/50 border border-cyan-500/20 rounded-2xl p-6">
                <p className="text-gray-300 leading-relaxed mb-4">
                  個人情報の取扱いに関するお問い合わせは、以下までご連絡ください：
                </p>
                <div className="space-y-2 text-gray-300">
                  <p><strong className="text-white">株式会社 空間Lab</strong></p>
                  <p>個人情報保護管理者</p>
                  <p>ウェブサイト：<a href="https://kukan-lab.com/" target="_blank" rel="noopener noreferrer" className="text-cyan-400 hover:text-cyan-300 transition-colors">https://kukan-lab.com/</a></p>
                  <p className="text-sm text-gray-400 mt-4">※お問い合わせは、トップページのお問い合わせフォームからもご利用いただけます</p>
                </div>
              </div>
            </section>
          </div>

          <div className="mt-12 text-center">
            <button onClick={scrollToTop} className="inline-flex items-center gap-2 text-cyan-400 hover:text-cyan-300 transition-colors cursor-pointer">
              <i className="ri-arrow-up-line"></i>
              <span>ページトップへ戻る</span>
            </button>
          </div>
        </div>
      </main>

      {/* フッター */}
      <footer className="relative bg-slate-950 border-t border-cyan-500/20 py-8 px-4 sm:px-6 lg:px-8">
        <div className="max-w-6xl mx-auto text-center">
          <p className="text-gray-400 text-sm mb-2">
            &copy; 2025 株式会社 空間Lab. All rights reserved.
          </p>
          <div className="flex justify-center gap-4 text-sm">
            <Link to="/" className="text-gray-400 hover:text-cyan-400 transition-colors">
              トップページ
            </Link>
            <Link to="/privacy" className="text-cyan-400">
              プライバシーポリシー
            </Link>
            <Link to="/legal" className="text-gray-400 hover:text-cyan-400 transition-colors">
              特定商取引法
            </Link>
          </div>
        </div>
      </footer>
    </div>
  );
}
